<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import Paginator from '../../components/paginator.svelte'
  import FilterTabs from '../../components/filter_tabs.svelte'
  import SearchInput from '../../components/search_input.svelte'
  import FilterSelect from '../../components/filter_select.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'

  let {
    users = [],
    pagy = { page: 1, pages: 1, count: 0 },
    total_count = null,
    mode = 'needs_review',
    filters = {},
    sort_options = [],
    report_reason_options = [],
    profile_visibility_options = []
  } = $props()

  let searchValue = $state(filters.search || '')

  // Unset filters are left out of the URL, like the other lists.
  const applyFilters = (changes) => {
    const params = {
      mode,
      search: filters.search,
      report_reason: filters.report_reason,
      profile_visibility: filters.profile_visibility,
      sort: filters.sort,
      ...changes
    }
    router.get(
      '/user-reports',
      Object.fromEntries(Object.entries(params).filter(([, value]) => value != null && value !== '')),
      { preserveState: true, preserveScroll: true }
    )
  }

  const approve = (user) => {
    router.patch(`/user-reports/${user.id}/review`, { review_action: 'approve' }, { preserveScroll: true })
  }

  const clearIcon = async (user) => {
    const confirmed = await confirm({
      title: 'Clear User Icon',
      variant: 'error',
      body: "This will remove the user's profile icon and dismiss all reports. Are you sure?",
      confirmLabel: 'Clear Icon'
    })
    if (!confirmed) return
    router.patch(`/user-reports/${user.id}/review`, { review_action: 'clear_icon' }, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Reports" subtitle="Review reported members" count={pagy.count} total={total_count} />

  <FilterBar>
    {#snippet start()}
      <FilterTabs
        tabs={[{ key: 'needs_review', label: 'Needs Review' }, { key: 'all', label: 'All Users' }]}
        active={mode}
        param="mode"
      />
    {/snippet}
  </FilterBar>

  <FilterBar>
    {#snippet start()}
      <SearchInput bind:value={searchValue} placeholder="Search users…" />
      <FilterSelect
        label="Report Reason"
        value={filters.report_reason || ''}
        placeholder="Any"
        options={report_reason_options}
        onchange={(v) => applyFilters({ report_reason: v || undefined })}
      />
      <FilterSelect
        label="Profile Visibility"
        value={filters.profile_visibility || ''}
        placeholder="Any"
        options={profile_visibility_options}
        onchange={(v) => applyFilters({ profile_visibility: v || undefined })}
      />
      <FilterSelect
        label="Sort"
        value={filters.sort}
        placeholder={null}
        options={sort_options}
        onchange={(v) => applyFilters({ sort: v })}
      />
    {/snippet}
  </FilterBar>

  <EntityList
    entity="user_report"
    rows={users}
    emptyMessage={mode === 'needs_review' ? 'No users with unreviewed reports.' : 'No users found.'}
  >
    {#snippet actions(user)}
      <Button variant="ghost" size="sm" square icon="check" class="text-success" title="Dismiss Reports" aria-label="Dismiss Reports" onclick={() => approve(user)} />
      {#if user.icon_image}
        <Button variant="ghost" size="sm" square icon="close" class="text-error" title="Clear Icon" aria-label="Clear Icon" onclick={() => clearIcon(user)} />
      {/if}
    {/snippet}
  </EntityList>

  <Paginator {...pagy} />
</Layout>
